import React, { useCallback, useState } from 'react';
import styles from './index.module.scss';
import ConsentBannerScreen from '../lm-1test-registration-flow-wrapper/components/consent-banner-screen';
import CookieManagementScreen from '../lm-1test-registration-flow-wrapper/components/cookie-management-screen';
import CompanyInfoScreen from '../lm-1test-registration-flow-wrapper/components/company-info-screen';
import FaqScreen from '../lm-1test-registration-flow-wrapper/components/faq-screen';

const SCREEN = {
  BANNER: 0,
  COOKIE_SETTINGS: 1,
  COMPANY_INFO: 2,
  FAQ: 3
};

const Lm1TestCookieConsentFlowWrapper = ({ children, enabled = true }) => {
  const [flowCompleted, setFlowCompleted] = useState(() => !enabled);
  const [screenNumber, setScreenNumber] = useState(SCREEN.BANNER);

  const completeFlow = useCallback(() => setFlowCompleted(true), []);

  if (flowCompleted) {
    return <>{children}</>;
  }

  const handleSharedScreenNumber = (number) => {
    switch (number) {
      case 1:
        return completeFlow();
      case 2:
        return setScreenNumber(SCREEN.COMPANY_INFO);
      case 3:
        return setScreenNumber(SCREEN.FAQ);
      default:
        return setScreenNumber(SCREEN.COOKIE_SETTINGS);
    }
  };

  const getScreen = () => {
    switch (screenNumber) {
      case SCREEN.COOKIE_SETTINGS:
        return (
          <CookieManagementScreen setScreenNumber={handleSharedScreenNumber} />
        );
      case SCREEN.COMPANY_INFO:
        return (
          <CompanyInfoScreen
            setScreenNumber={handleSharedScreenNumber}
            handleBackButtonClick={() =>
              setScreenNumber(SCREEN.COOKIE_SETTINGS)
            }
          />
        );
      case SCREEN.FAQ:
        return (
          <FaqScreen
            setScreenNumber={handleSharedScreenNumber}
            handleBackButtonClick={() =>
              setScreenNumber(SCREEN.COOKIE_SETTINGS)
            }
          />
        );
      case SCREEN.BANNER:
      default:
        return (
          <ConsentBannerScreen
            onAcceptAll={completeFlow}
            onLearnMore={() => setScreenNumber(SCREEN.COOKIE_SETTINGS)}
          >
            {children}
          </ConsentBannerScreen>
        );
    }
  };

  return <div className={styles.cookieConsentFlow}>{getScreen()}</div>;
};

export default Lm1TestCookieConsentFlowWrapper;
